export { default } from 'features/reward/routes/rewards-history-route';
